import {
  ChevronDownIcon,
  ChevronsUpIcon,
  ChevronUpIcon,
  type LucideIcon,
  PauseIcon,
} from "lucide-react";

import { Center } from "@/components/Center";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

import { cn } from "@/lib/utils";
import { JobPriority } from "@/types";

const PRIORITY_CONFIG: Record<
  JobPriority,
  { icon: LucideIcon; chipClassName: string; iconClassName: string }
> = {
  [JobPriority.HIGH]: {
    icon: ChevronsUpIcon,
    chipClassName: "bg-[#D14343]/10 text-[#9B3030]",
    iconClassName: "text-[#9B3030]",
  },
  [JobPriority.MEDIUM]: {
    icon: ChevronUpIcon,
    chipClassName: "bg-[#E67E22]/10 text-[#c2410c]",
    iconClassName: "text-[#c2410c]",
  },
  [JobPriority.LOW]: {
    icon: ChevronDownIcon,
    chipClassName: "bg-[#2D9CDB]/10 text-[#1F6FA8]",
    iconClassName: "text-[#1F6FA8]",
  },
  [JobPriority.BACKBURNERED]: {
    icon: PauseIcon,
    chipClassName: "bg-[#9B9B9B]/10 text-[#6B6B6B]",
    iconClassName: "text-[#6B6B6B]",
  },
};

export const DashboardPriorityCell = ({
  priority,
}: {
  priority: JobPriority | null;
}) => {
  const render = () => {
    if (priority === null) {
      return (
        <Row className="justify-start">
          <Center className="h-6 w-6 rounded-full">
            <Text className="text-sm font-normal text-slate-300">—</Text>
          </Center>
        </Row>
      );
    }

    const config = PRIORITY_CONFIG[priority];
    const Icon = config.icon;
    return (
      <Row className="justify-start">
        <Center className={cn("h-6 w-6 rounded-full", config.chipClassName)}>
          <Icon
            className={cn("h-3 w-3 shrink-0", config.iconClassName)}
            strokeWidth={2}
          />
        </Center>
      </Row>
    );
  };

  return render();
};
